import type { TooltipContext } from "primevue/tooltip"

export default {
    root: ({ context }: { context: TooltipContext }) => ({
        class: [
            // Position and Shadows
            "absolute",
            "shadow-md",
            "p-fadein",
            "border border-black-text",
            "bg-white",
            "max-w-xs",
            // Spacing
            {
                "py-0 px-1 ml-2":
                    (context == null ? 0 : context.right) ||
                    (context == null ? 0 : context.left) ||
                    (!(context != null && context.right) &&
                        !(context != null && context.left) &&
                        !(context != null && context.top) &&
                        !(context != null && context.bottom)),
                "py-0 px-0 !-ml-1": context == null ? 0 : context.left,
                "py-1 px-0 mt-2":
                    (context == null ? 0 : context.top) ||
                    (context == null ? 0 : context.bottom),
            },
        ],
    }),
    arrow: ({ context }: { context: TooltipContext }) => ({
        class: [
            // Position
            "absolute",
            // Size
            "w-0",
            "h-0",
            // Shape
            "border-transparent",
            "border-solid",
            {
                "border-y-[0.25rem] border-r-[0.25rem] border-l-0 border-r-black-text":
                    (context == null ? 0 : context.right) ||
                    (!(context != null && context.right) &&
                        !(context != null && context.left) &&
                        !(context != null && context.top) &&
                        !(context != null && context.bottom)),
                "border-y-[0.25rem] border-l-[0.25rem] border-r-0 border-l-black-text":
                    context == null ? 0 : context.left,
                "border-x-[0.25rem] border-t-[0.25rem] border-b-0 border-t-black-text":
                    context == null ? 0 : context.top,
                "border-x-[0.25rem] border-b-[0.25rem] border-t-0 border-b-black-text":
                    context == null ? 0 : context.bottom,
            },
            // Spacing
            {
                "-mt-1 -ml-1":
                    (context == null ? 0 : context.right) ||
                    (!(context != null && context.right) &&
                        !(context != null && context.left) &&
                        !(context != null && context.top) &&
                        !(context != null && context.bottom)),
                "-mt-1 -mr-1": context == null ? 0 : context.left,
                "-ml-1 -mt-1":
                    (context == null ? 0 : context.top) ||
                    (context == null ? 0 : context.bottom),
            },
        ],
    }),
    text: {
        class: [
            "max-w-xs",
            "px-2 py-1.5",
            "bg-white",
            "text-sm",
            "text-black-text",
            // "leading-none",
            "rounded-md",
            "whitespace-pre-line",
            "break-words",
        ],
    },
}
